
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import './bootstrap';
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import VueTelInput from 'vue-tel-input'
import VueExcelXlsx from "vue-excel-xlsx"
import VueRouter from 'vue-router'
import CKEditor from '@ckeditor/ckeditor5-vue'
// import 'babel-polyfill'
import 'vue-tel-input/dist/vue-tel-input.css'
import swal from 'sweetalert';

const eventsHub = new Vue();

window.Vue = Vue;
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'es6-promise/auto'
import IdleVue from 'idle-vue'


Vue.use(Vuetify);
Vue.use(VueTelInput);
Vue.use(VueExcelXlsx);
Vue.use(VueRouter);
Vue.use(CKEditor);
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 10 * 60 * 1000
})



import elementui from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import axios from 'axios'

import {Loading} from 'element-ui'

//修改原型链，全局使用axios,这样之后可在每个组件的methods中调用$axios命令完成数据请求
Vue.prototype.$axios=axios
// 安装各类插件
Vue.use(elementui)

let loading;
//内存中正在请求的数量
let loadingNum=0;
function startLoading() {
    if(loadingNum==0){
        loading = Loading.service({
            lock: true,
            text: 'Loading...',
            background:'rgba(255,255,255,0.5)',
        })
    }
    //请求数量加1
    loadingNum++;
}
function endLoading() {
    //请求数量减1
    loadingNum--
    if(loadingNum<=0){
        loading.close()
    }
}

//请求数据拦截器
axios.interceptors.request.use(request => {
    if (request.loading !== false) {
        startLoading();
    }
    return request
}, err => {
    return Promise.reject(err);
});


//接收响应拦截器
axios.interceptors.response.use(response => {
    if (response.config.loading !== false) {
        endLoading();
    }
    return response
}, err => {
    endLoading();
    message.error(err.message);
    return Promise.reject(err);
});


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('example-component', require('./components/ExampleComponent'));
Vue.component('app', require('./components/App'));
Vue.component('register', require('./components/Register'));
Vue.component('login', require('./components/Login'));

Vue.component('superadmin-panel', require('./components/SuperadminPanel'));
Vue.component('finance-panel', require('./components/FinancePanel'));

Vue.component('admin-create', require('./components/Admins/AdminCreate'));
Vue.component('admin-edit', require('./components/Admins/AdminEdit'));

Vue.component('groups', require('./components/Groups/Groups'));
Vue.component('group', require('./components/Groups/Group'));
Vue.component('group-create', require('./components/Groups/GroupCreate'));
Vue.component('group-edit', require('./components/Groups/GroupEdit'));

Vue.component('outlet-create', require('./components/Outlets/OutletCreate'));
Vue.component('outlet-edit', require('./components/Outlets/OutletEdit'));
Vue.component('outlets', require('./components/Outlets/Outlets'));
Vue.component('outlet', require('./components/Outlets/Outlet'));
Vue.component('outlet-reports', require('./components/Outlets/Report'));
Vue.component('outlet-admins', require('./components/Outlets/OutletAdmin'));
Vue.component('online', require('./components/Outlets/Online'));

Vue.component('queues', require('./components/Queues/Queues'));
Vue.component('queue-create', require('./components/Queues/QueueCreate'));
Vue.component('queue-edit', require('./components/Queues/QueueEdit'));
Vue.component('queue', require('./components/Queues/Queue'));
Vue.component('queue-admin', require('./components/Queues/QueueAdmin'));
Vue.component('queue-appointment', require('./components/Queues/QueueAppointment'));
Vue.component('queue-monitor', require('./components/Queues/Monitor'));
Vue.component('onsite', require('./components/Onsite'));
Vue.component('record', require('./components/Queues/Record'));

Vue.component('services', require('./components/Services/Services'));
Vue.component('service-create', require('./components/Services/ServiceCreate'));
Vue.component('service-edit', require('./components/Services/ServiceEdit'));

Vue.component('ip-create', require('./components/OutletIPs/OutletIPCreate'));
Vue.component('ip-edit', require('./components/OutletIPs/OutletIPEdit'));

Vue.component('my-booking', require('./components/MyBooking'));

Vue.component('timeslot-limit', require('./components/Queues/TimeslotLimit'));

Vue.component('live-details', require('./components/LiveDetails'));
Vue.component('appointment-details', require('./components/AppointmentDetails'));
Vue.component('blacklist-create', require('./components/Blacklist/BlacklistCreate'));

Vue.component('breadcrumbs', require('./components/BreadCrumbs'));

Vue.component('advertise', require('./components/Advertise'));
Vue.component('vertical-advertise', require('./components/VerticalAdvertise.vue'));
Vue.component('vertical-calling-number', require('./components/VerticalCallingNumber'));
Vue.component('calling-number', require('./components/CallingNumber'));
Vue.component('calling-number2', require('./components/CallingNumber2'));

Vue.component('display-number-settings', require('./components/DisplayNumberSettings'));

Vue.component('sms-statistic', require('./components/SMSStatistic'));

Vue.component('admin-layout', require('./components/Layouts/Admin'))
Vue.component('dashboard', require('./components/Dashboard'))

Vue.component('monitor-queues', require('./components/Outlets/MonitorQueues'))
Vue.component('date-input', require('./components/Basic/DateInput'))

Vue.component('missed-number', require('./components/MissedNumber'))
Vue.component('horizontal-screen', require('./components/HorizontalScreen.vue'))

new Vue({
    el: '#app',
    vuetify : new Vuetify({
        theme: {
            themes: {
                light: {
                    primary: '#3f51b5',
                    secondary: '#b0bec5',
                    accent: '#8c9eff',
                    error: '#b71c1c',
                },
            },
            options: { customProperties: true },
        },
    }),
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js